<template>
    <section class="content">
      <!-- Default box -->
      <div
        class="card card-solid"
        :style="{ 'min-height': $store.state.screenHeight - 200 + 'px' }"
      >
        <div class="card-header pb-0">
          <div class="row">
            <div class="form-group row col-sm-3 pb-0">
              <label
                for="date"
                class="col-sm-4 col-form-label text-right pb-0"
              >เลือกสาขา</label>
              <div class="col-sm-8 pb-0">
                <select
                  class="custom-select mr-sm-2 pb-0"
                  id="Host"
                  v-model="branch"
                  @change="getGroupItem"
                >
                  <option value="0">-- ทุกสาขา --</option>
                  <option
                    v-for="(b, i) in $store.state.branch_list"
                    :key="'branch' + i"
                    :value="b"
                  >{{ b.branch_name }}</option>
                </select>
              </div>
            </div>
            <div class="form-group row col-sm-3 pb-0">
              <label
                for="date"
                class="col-sm-4 col-form-label text-right"
              >จากวันที่</label>
              <div class="col-sm-8">
                <a-date-picker
                  v-model="startDate"
                  :format="'DD/MM/YYYY'"
                  style="width: 100%;"
                />
              </div>
            </div>
            <div class="form-group row col-sm-3 pb-0">
              <label
                for="date"
                class="col-sm-4 col-form-label text-right"
              >ถึงวันที่</label>
              <div class="col-sm-8">
                <a-date-picker
                  v-model="endDate"
                  :format="'DD/MM/YYYY'"
                  style="width: 100%;"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-sm-2"></div>
            <div class="col-sm-3">
              <button
                type="button"
                class="btn btn-success btn-block"
                @click="getReport"
              >
                <i class="fas fa-redo"></i> ประมวลผล
              </button>
            </div>
            <div class="col-sm-3">
              <form
                action="/static/pdf/report_calculate_rice.php"
                method="POST"
                target="_blank"
              >
                <input
                  type="hidden"
                  name="date_start"
                  v-model="startDate"
                >
                <input
                  type="hidden"
                  name="date_end"
                  v-model="endDate"
                >
                <input
                  type="hidden"
                  name="selected_groups"
                  :value="JSON.stringify(selectedGroupsForExport)"
                >
                <input
                  type="hidden"
                  name="data"
                  v-model="form_data"
                >
                <button
                  type="submit"
                  class="btn btn-primary btn-block"
                >
                  <i class="far fa-file-pdf"></i> บันทึกเป็น PDF
                </button>
              </form>
            </div>
            <div class="col-sm-3">
              <form
                action="/static/excel/report_calculate_rice.php"
                method="POST"
                target="_blank"
              >
                <input
                  type="hidden"
                  name="date_start"
                  v-model="startDate"
                >
                <input
                  type="hidden"
                  name="date_end"
                  v-model="endDate"
                >
                <input
                  type="hidden"
                  name="selected_groups"
                  :value="JSON.stringify(selectedGroupsForExport)"
                >
                <input
                  type="hidden"
                  name="data"
                  v-model="form_data"
                >
                <button
                  type="submit"
                  class="btn btn-info btn-block"
                >
                  <i class="far fa-file-excel"></i> บันทึกเป็น Excel
                </button>
              </form>
              <!-- <button
                @click="() => {exportExcel()}"
                type="button"
                class="btn btn-info btn-block"
              >
                <i class="far fa-file-excel"></i> บันทึกเป็น Excel
              </button> -->
            </div>
          </div>
          <div class="table-responsive-sm mt-3">
            <div v-for="(c, i) in report_data"
            v-show="report_data.length > 0"
            :key="'c' + i">
            <div>
              <Span style="font-size: 18px; font-weight: 700;">สาขา : {{ c.branch_name }} {{ c.summary_date }}</Span>
              <table class="table table-bordered">
              <!-- <div style="width:100%;" > -->
                <thead>
                  <!-- Header Row -->
                  <tr>
                    <!-- First cell is empty or a title for "Month" -->
                    <th style="text-align: center; color:black; background-color: #92D050; font-size: 18px;">ข้าวนึ่งเหลือ (Kg.)</th>
                    <th style="text-align: center; color:black; background-color: #92D050; font-size: 18px;">ข้าวเสียข้าวติดหม้อ (Kg.)</th>
                    <th style="text-align: center; color:black; background-color: #92D050; font-size: 18px;">ข้าวที่นึ่งได้ตามสมุด (Kg.)</th>
                    <th style="text-align: center; color:black; background-color: #92D050; font-size: 18px;">ยอดรวมสุทธิข้าวที่นึ่งได้ (Kg.)</th>
                    <th style="text-align: center; color:black; background-color: #9FC5E8; font-size: 18px;">จำนวนข้าวนึ่งที่ขายได้จริง (Kg.)</th>
                    <th style="text-align: center; color:black; background-color: #9FC5E8; font-size: 18px;">พักบิลวันนี้ (Kg.)</th>
                    <th style="text-align: center; color:black; background-color: #9FC5E8; font-size: 18px;">คีย์ย้อนหลัง (Kg.)</th>
                    <th style="text-align: center; color:black; background-color: #9FC5E8; font-size: 18px;">ยอดรวมสุทธิจำนวนข้าวนึ่ง ที่ขายได้จริง (Kg.)</th>
                    <th style="text-align: center; color:black; background-color: #FF99FE; font-size: 18px;">ขาด/เกิน</th>
                  </tr>
                </thead>
                <tbody>
                <tr>
                  <!-- First cell = Thai month name -->
                  <td style="text-align: center; font-size: 16px;">
                    {{ c.summary.rice_remain }}
                  </td>

                  <td style="text-align: center; font-size: 16px;">
                    {{ c.summary.rice_waste }}
                  </td>

                  <td style="text-align: center; font-size: 16px;">
                    {{ c.summary.rice_steamed }}
                  </td>

                  <td style="text-align: center; font-size: 16px;">
                    {{ c.summary.rice_total }}
                  </td>

                  <td style="text-align: center; font-size: 16px;">
                    {{ c.summary.rice_sale }}
                  </td>

                  <td style="text-align: center; font-size: 16px;">
                    {{ c.summary.sale_holdbil }}
                  </td>
                  <td style="text-align: center; font-size: 16px;">
                    {{ c.summary.sale_before_holdbil }}
                  </td>
                  <td style="text-align: center; font-size: 16px;">
                    {{ c.summary.sale_summary }}
                  </td>
                  <td
                    style="text-align: center; font-size: 16px;"
                    :style="{
                      backgroundColor: c.summary.sale_over < 0 ? 'red' : '',
                      color: c.summary.sale_over < 0 ? 'black' : ''
                    }"
                  >
                    {{ c.summary.sale_over }}
                  </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  
  <script>
  import moment from 'moment'
  // import api from '../services/service_report'
  import apiCenterV2 from "../services/service_undefined_v2";
  import apiD from '../services/service'
  import * as XLSX from 'xlsx'
  import { saveAs } from 'file-saver';
  // import apiItem from '../services/service_item'
  
  export default {
    data () {
      const months = [
        "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", 
        "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", 
        "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
      ];
     
      const monthsEng =  [
        "january", "february", "march", "april", "may", "june",
        "july", "august", "september", "october", "november", "december"
      ];
      const currentMonthIndex = new Date().getMonth(); // Get current month index (0-11)
      const currentYearCE = new Date().getFullYear(); // Get current Gregorian year
      // const currentYearBE = currentYearCE + 543; // Convert to Buddhist Era
      return {
        report_data: [],
        selectedYear: currentYearCE, // Store as Gregorian year
        yearRange: Array.from({ length: 11 }, (_, i) => {
          const yearCE = currentYearCE - 5 + i; // Calculate Gregorian Year
          return {
            gregorian: yearCE, // Store Gregorian year internally
            buddhist: yearCE + 543 // Display as Buddhist year
          };
        }),
        monthNameMap: {
          january: "มกราคม",
          february: "กุมภาพันธ์",
          march: "มีนาคม",
          april: "เมษายน",
          may: "พฤษภาคม",
          june: "มิถุนายน",
          july: "กรกฎาคม",
          august: "สิงหาคม",
          september: "กันยายน",
          october: "ตุลาคม",
          november: "พฤศจิกายน",
          december: "ธันวาคม"
        },
        startDate: moment(new Date()),
        endDate: moment(new Date()),
        startMonth: months[currentMonthIndex], // Stores selected start month (1-12)
        endMonth: months[currentMonthIndex],   // Stores selected end month (1-12)
        months,
        monthsEng,
        header: {
          headers: {
            'Access-Token': sessionStorage.token
          }
        },
        tableData: [
          { item_code: 'ABC123', qty: 10, avg_cost_sale: 1000 },
          { item_code: 'XYZ789', qty: 5,  avg_cost_sale: 2000 },
          { item_code: 'LMN456', qty: 7,  avg_cost_sale: 1500 },
        ],
        form_data: '',
        branch: 0,
        strucB: [],
        group_item: [],
        selectedGroups: ["all"], // Stores selected group codes
        group: [],
        price_cal_vat: 0
      }
    },

    computed: {
        selectedGroupsForExport () {
          return this.selectedGroups.includes('all') ? this.group_item.map(g => g.name) : this.selectedGroups;
        },
        monthsInRange () {
          const monthNames = [
            "มกราคม", "กุมภาพันธ์", "มีนาคม",   "เมษายน",
            "พฤษภาคม", "มิถุนายน",  "กรกฎาคม",  "สิงหาคม",
            "กันยายน",  "ตุลาคม",   "พฤศจิกายน","ธันวาคม"
          ];

          const startIndex = monthNames.indexOf(this.startMonth);
          const endIndex   = monthNames.indexOf(this.endMonth);

          // If the user’s endMonth is actually earlier than startMonth,
          // you might handle it differently. For now, we assume endIndex >= startIndex.
          if (startIndex < 0 || endIndex < 0 || endIndex < startIndex) return [];

          // Build an array of months from startMonth to endMonth
          const months = [];
          for (let i = startIndex; i <= endIndex; i++) {
            months.push(monthNames[i]);
          }

          return months;
        }
    },
    watch: {
      startMonth () {
        this.clearReportData();
      },
      endMonth () {
        this.clearReportData();
      }
    },
    methods: {
      exportExcel () {
        // 1) Create a new workbook
        const workbook = XLSX.utils.book_new();

        // 2) Figure out which groups to show
        const selectedGroupsList = this.selectedGroups.includes("all")
          ? this.group_item
          : this.group_item.filter(item => this.selectedGroups.includes(item.name));

        // 3) Loop over each branch and build a sheet
        this.report_data.forEach(branchObj => {
          // A) Prepare the 2D array for this branch’s data
          const sheetData = [];

          // (A1) Add a merged header row for the branch name
          sheetData.push([`รายงานสรุปยอดขายประจำเดือน - ${branchObj.branch_name}`]);

          // (A2) Next row: the usual table header
          const headerRow = ["เดือน", ...selectedGroupsList.map(g => g.name), "ยอดรวม"];
          sheetData.push(headerRow);

          // B) Populate data rows
          branchObj.results.forEach(monthResult => {
            const rowData = [];
            // Thai month
            const thaiMonth = this.getThaiMonthName(monthResult.month);
            rowData.push(thaiMonth);

            // Each group’s avg_cost_sale
            selectedGroupsList.forEach(g => {
              const foundItem = monthResult.data.find(item => item.name === g.name);
              const value = foundItem ? parseFloat(foundItem.avg_cost_sale || 0) : 0;
              rowData.push(value);
            });

            // Total
            const totalForThisMonth = monthResult.data
              .filter(item =>
                this.selectedGroups.includes("all") ||
                this.selectedGroups.includes(item.name)
              )
              .reduce((sum, item) => sum + (parseFloat(item.avg_cost_sale) || 0), 0);
            rowData.push(totalForThisMonth);

            sheetData.push(rowData);
          });

          // C) Convert sheetData to a worksheet
          const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

          // --- (C1) Merge the first row across all columns ---
          // We have 1 col for "เดือน", plus `selectedGroupsList.length` columns,
          // plus 1 col for "ยอดรวม" = totalCols
          const totalCols = 1 + selectedGroupsList.length + 1;
          worksheet["!merges"] = [
            {
              s: { r: 0, c: 0 },             // start cell (row 0, col 0)
              e: { r: 0, c: totalCols - 1 }  // end cell   (row 0, col N)
            }
          ];

          // --- (C2) Set column widths (optional) ---
          worksheet["!cols"] = new Array(totalCols).fill({ wch: 15 });

          // --- (C3) Style cells: font, alignment, header color, numeric format ---
          const range = XLSX.utils.decode_range(worksheet["!ref"]);
          for (let R = range.s.r; R <= range.e.r; R++) {
            for (let C = range.s.c; C <= range.e.c; C++) {
              const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
              const cell = worksheet[cellRef];
              if (!cell) continue;

              // Base style for all cells
              cell.s = {
                font: { name: "Angsana New", sz: 16 },
                alignment: { horizontal: "center", vertical: "center" }
              };

              // (1) If this is the header row (row index = 1), apply background color
              if (R === 1) {
                cell.s.fill = {
                  patternType: "solid",
                  fgColor: { rgb: "FFFABF8F" }  // light orange color
                };
              }

              // (2) For data rows (R >= 2), columns that are numeric => apply number format
              //     - "เดือน" is column 0
              //     - group columns = 1..(selectedGroupsList.length)
              //     - total column = selectedGroupsList.length + 1
              if (R >= 2) {
                // If this column is 1..N or the last column (N+1), it holds numeric values
                if ((C >= 1 && C <= selectedGroupsList.length) || (C === selectedGroupsList.length + 1)) {
                  cell.t = "n";                // type = number
                  cell.z = "#,###.00";         // number format
                }
              }
            }
          }

          // --- (C4) Optionally, style the merged top row (row index = 0) if you like ---
          const topCellRef = XLSX.utils.encode_cell({ r: 0, c: 0 });
          if (worksheet[topCellRef]) {
            worksheet[topCellRef].s = {
              font: { name: "Angsana New", sz: 18, bold: true },
              alignment: { horizontal: "center", vertical: "center" }
            };
          }

          // D) Append the worksheet to the workbook
          let sheetName = branchObj.branch_name;
          if (sheetName.length > 31) {
            sheetName = sheetName.substring(0, 31);
          }
          XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        });

        // 4) Generate file and download
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array',  cellStyles: true, // <-- important
        cellNF: true });
        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        });
        saveAs(blob, 'รายงานสรุปยอดขายประจำเดือน_Report.xlsx');
      },
      getTotal (data) {
          return data
          .reduce((sum, item) => sum + (parseFloat(item.avg_cost_sale) || 0), 0)
          .toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
      },
      getThaiMonthName (month) {
        return this.monthNameMap[month.toLowerCase()] || month;
      },
      getAvgCostSale (dataArray, groupName) {
        const found = dataArray.find(item => item.name === groupName);
        return found
          ? parseFloat(found.avg_cost_sale || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          : '-';
      },
      clearReportData () {
        // this.report_data = [];
        // this.form_data = '';
      },
      handleChange (values) {
          console.log("handleChange =>", values);

          // 1) Normalize the selection
          if (values.includes("all")) {
            // If user selected 'all', force only ["all"] in selectedGroups
            this.selectedGroups = ["all"];
          } else {
            // Remove 'all' and any empty/invalid entries
            this.selectedGroups = values.filter(v => v && v !== "all");
          }

          // 2) Build a filtered version of `report_data` 
          //    so only items that match `this.selectedGroups` remain.
          const filteredData = this.report_data.map(branchObj => {
            return {
              ...branchObj,
              results: branchObj.results.map(monthResult => {
                return {
                  ...monthResult,
                  data: monthResult.data.filter(item => {
                    // If user has 'all' selected, keep everything
                    if (this.selectedGroups.includes("all")) return true;
                    // Otherwise, only keep items whose name is in selectedGroups
                    return this.selectedGroups.includes(
                      (item.name || "").trim()
                    );
                  })
                };
              })
            };
          });

          console.log(filteredData);

          // 3) Update form_data so PDF/Excel exports reflect the new selection
          this.form_data = JSON.stringify(filteredData);

          // (OPTIONAL) If you also want the table in the UI to update immediately,
          // you can do:
          // this.report_data = filteredData;
        },
      handleSelect (value, option) {
        // Fires when a single option is selected. 
        // 'value' = the selected value, 'option' = the <a-select-option> node props
        if (value === "all") {
          this.selectedGroups = ["all"]
        } else {
          this.selectedGroups = this.selectedGroups.filter(v => v !== "all");
        }
        // console.log("handleSelect =>", value, option);
      },
      handleDeselect (value) {
        // Fires when an item is deselected in multiple mode.
        console.log("handleDeselect =>", value);
      },
      getReport () {
        var branch = 0
        if (this.branch !== 0) {
          branch = this.branch.id
        }

        var obj = {
          start_date: moment(this.startDate).format("YYYY-MM-DD"), // Set formatted start date
          end_date: moment(this.endDate).format("YYYY-MM-DD"), // Set formatted end date
          branch_id: branch,
        };

        this.$store.state.isLoading = true;
        // console.log(obj, moment(new Date())); // Debugging to check the object
        apiCenterV2.reportsCalculateRice(
            obj,
            this.header,
            results => {
              this.$store.state.isLoading = false
              if (results.status) {
                // console.log(  results );
                var sortData = results.data.data.sort((a,b) => a.branch_name.localeCompare(b.branch_name))
                this.report_data = sortData
                console.log(  sortData );
                this.form_data = JSON.stringify(sortData)
              } else {
                this.$notification['warning']({
                  message: 'ดึงข้อมูลรายงานไม่ได้',
                  description: results.message
                })
              }
            },
            errors => {
              this.$store.commit("Loading");
              this.$notification["warning"]({
                message: "ไม่สามารถเข้าถึงข้อมูลได้",
                description: errors.data.message
              });
            }
          );
        console.log(obj);
      
      },
      getGroupItem () {
        var branch = 0
        if (parseInt(this.branch) === 0) {
          branch = this.$store.state.branch_list[0]
        } else {
          branch = this.branch
        }
        // apiItem.itemGroup(
        apiD.callMisApi(
          branch.dyn_address + '/' + 'product/v1/item/group',
          {
            headers: {
              'client-token': branch.access_token,
              'access-token': sessionStorage.token
            }
          },
          {},
          result => {
            // console.log(result.response)
            if (result.response === 'success') {
              // console.log(result.data);
              // this.group_item = result.data.filter((e) => e.name !== "ข้าวหม่า")
              this.group_item = result.data
                // first, filter out "ข้าวหม่า"
                .filter((item) => item.name !== "ข้าวหม่า")
                // then, change "ข้าวเหนียว" to "ข้าวสารเหนียว"
                .map((item) => {
                  if (item.name === "ข้าวเหนียว") {
                    return {
                      ...item,
                      name: "ข้าวสารเหนียว"
                    }
                  }
                  return item
                })
            } else {
              this.alert('warning', 'ดึงข้อมูลสินค้าไม่ได้', result.message)
            }
          },
          error => {
            this.alert('error', 'ไม่สามารถเข้าถึงข้อมูล', error.message)
          }
        )
      }
    },
    mounted () {
      this.checkUser()
      this.getBranch()
      setTimeout(() => {
        this.getGroupItem()
      }, 1000)
      // this.getReport()
    }
  }
  </script>
  


// WEBPACK FOOTER //
// src/views/report_calculate_rice.vue